import { SmartQueriesApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useSmartQueryAPI(): SmartQueriesApi {
  return new SmartQueriesApi(apiConfig);
}
